import React, { useState } from 'react';
import AIAlertsPanel from './AIAlertsPanel';
import AIPriorityLeaderboard from './AIPriorityLeaderboard';

export default function AIIntelligenceCenter({ projectId, onTaskClick, pendingAlertId, onPendingAlertConsumed }) {
    const [activeTab, setActiveTab] = useState('alerts'); // 'alerts' | 'priority'

    return (
        <div className="bg-white dark:bg-[#1f1f1f] border border-slate-100 dark:border-[#303030] rounded-2xl shadow-[0px_8px_24px_rgba(25,28,29,0.06)] flex flex-col h-full min-h-[400px] max-h-[500px]">
            {/* Header / Tabs */}
            <div className="flex items-center justify-between px-5 pt-5 pb-3 border-b border-slate-100 dark:border-[#303030]">
                <div className="flex items-center gap-6">
                    <button
                        onClick={() => setActiveTab('alerts')}
                        className={`relative pb-3 text-sm font-bold transition-colors ${activeTab === 'alerts'
                                ? 'text-[#003263] dark:text-[#a7c8ff]'
                                : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-300'
                            }`}
                    >
                        Action Alerts
                        {activeTab === 'alerts' && (
                            <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#003263] dark:bg-[#a7c8ff] rounded-t-full" />
                        )}
                    </button>
                    <button
                        onClick={() => setActiveTab('priority')}
                        className={`relative pb-3 text-sm font-bold transition-colors ${activeTab === 'priority'
                                ? 'text-[#003263] dark:text-[#a7c8ff]'
                                : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-300'
                            }`}
                    >
                        Priority Ranking
                        {activeTab === 'priority' && (
                            <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#003263] dark:bg-[#a7c8ff] rounded-t-full" />
                        )}
                    </button>
                </div>
            </div>

            {/* Content Area */}
            <div className="flex-1 min-h-0 p-5 overflow-hidden">
                <div className={activeTab === 'alerts' ? 'h-full flex flex-col' : 'hidden'}>
                    <AIAlertsPanel
                        projectId={projectId}
                        onTaskClick={onTaskClick}
                        pendingAlertId={pendingAlertId}
                        onPendingAlertConsumed={onPendingAlertConsumed}
                    />
                </div>
                <div className={activeTab === 'priority' ? 'h-full flex flex-col' : 'hidden'}>
                    <AIPriorityLeaderboard projectId={projectId} onTaskClick={onTaskClick} />
                </div>
            </div>
        </div>
    );
}
